module.exports = new __parcel__URL__("shelf-foreground.38006fce.png").toString();